import { SPINNER } from 'ngx-ui-loader';

export const CONFIGCONSTANTS = {
  dataTableListing: {
    columnRecordMissingText: '-'
  },
  siteName: "Medify",
  dateFormat: "DD-mmm-yyyy hh:mm A",
  momentDateTime24Format: "DD-MMM-YYYY hh:mm A",
  momentDateTime12Format: "DD-MMM-YYYY h:mm A",
  momentTime24Format: "hh:mm:ss",
  momentTime12Format: "hh:mm A",
  momentDateFormat: "DD-MMM-YYYY",
  dobFormat: "DD-mmm-yyyy",
  languageOption: true,
  dateRangeLocale: {
    format: "DD-MMM-YYYY",
    separator: " To ",
    applyLabel: "Apply",
    cancleLabel: "Cancel"
  },
  'dateRangeConfig': {
    rangeInputFormat: 'DD-MMM-YYYY',
    containerClass: 'theme-dark-blue',
    rangeSeparator: ' To '
  },
  "CK-Editor-config": {
    allowedContent: true,
    extraPlugins: "sourcedialog,uploadimage",
    forcePasteAsPlainText: true,
    removePlugins: "sourcearea",
    language: "en",
    // removeButtons:"Cut,Copy,Paste,PasteText,PasteFromWord,Undo,Redo,Find,Replace,
    // SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,
    // HiddenField,Image,Flash,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,About",
    uploadUrl: 'https://ckeditor.com/apps/ckfinder/3.4.5/core/connector/php/connector.php?command=QuickUpload&type=Files&responseType=json',
    // Configure your file manager integration. This example uses CKFinder 3 for PHP.
    // filebrowserBrowseUrl: 'https://ckeditor.com/apps/ckfinder/3.4.5/ckfinder.html',
    // filebrowserImageBrowseUrl: 'https://ckeditor.com/apps/ckfinder/3.4.5/ckfinder.html?type=Images',
    // filebrowserUploadUrl: 'https://ckeditor.com/apps/ckfinder/3.4.5/core/connector/php/connector.php?command=QuickUpload&type=Files',
    filebrowserImageUploadUrl: 'https://ckeditor.com/apps/ckfinder/3.4.5/core/connector/php/connector.php?command=QuickUpload&type=Images',
    removeDialogTabs: 'image:advanced;link:advanced'
  },
  datatableConfig: {
    reorderable: false,
    scrollbarH: true,
    serverSorting: true,
    clientSorting: false,
    serverPaging: true,
    clientPaging: false,
    piningRight: false,
    headerHeight: 50,
    footerHeight: 50,
    rowHeight: "auto",
    dtMessages: {
      emptyMessage: "No data available",
      totalMessage: "Total Records"
    },
    page: {
      size: 10,
      pageNumber: 0,
      totalReords: 0
    },
    limitList: [10, 25, 50, 100]
  },
  statusClass: {
    Pending: "badge-secondary",
    Active: "badge-success",
    Inactive: "badge-danger",
    Approved: "badge-success",
    Disapproved: "badge-danger",
    Blocked: "badge-danger",
    Requested: "badge-warning",
    Confirmed: "badge-info",
    Accepted: "badge-info",
    Rejected: "badge-secondary",
    Delivered: "badge-success",
    Completed: "badge-success",
    Cancelled: "badge-danger",
    Yes: "badge-success",
    No: "badge-danger",
    Verified: "badge-success",
    Notverified: "badge-danger",
    Notrequired: "badge-secondary",
    Understocked: "understocked",
    Overstocked: "overstocked",
    'Out of Stock': "out-of-stock",
    'Sufficiently Stocked': "sufficiently-stocked",
    'red': "red",
    'green': "green",
    'yellow': "yellow"
  },
  loaderConfig: {
    fgsColor: '#9370db',
    bgsColor: "#ffffff",
    bgsOpacity: 1,
    spinnerType: SPINNER.ballSpinClockwise
    // "bgsColor": "#00ACC1",
    // "bgsPosition": "bottom-right",
    // "bgsSize": 60,
    // "bgsType": "ball-spin-clockwise",
    // "blur": 5,
    // "fgsPosition": "center-center",
    // "fgsSize": 60,
    // "fgsType": "ball-spin-clockwise",
    // "gap": 24,
    // "logoPosition": "center-center",
    // "logoSize": 120,
    // "logoUrl": "",
    // "masterLoaderId": "master",
    // "overlayBorderRadius": "0",
    // "overlayColor": "rgba(40, 40, 40, 0.8)",
    // "pbDirection": "ltr",
    // "pbThickness": 3,
    // "hasProgressBar": true,
    // "text": "",
    // "textColor": "#FFFFFF",
    // "textPosition": "center-center",
    // "threshold": 500
  },
  patterns: {
    leadingTrailingSpace: "^(?! ).*(?<! )$",
    firstNameLastName: "[A-Za-z ]*",
    mobileNumber: "^((\\+91-?)|0)?[0-9]{10,13}$"
  },
  firstNameLastName: {
    minlength: 0,
    maxlength: 40
  },
  validators: {
    mobileNumber: {
      minlength: 10,
      maxlength: 13
    }
  },
  datePickerConfig: {
    dateInputFormat: 'DD-MMM-YYYY',
    containerClass: 'theme-dark-blue'
  },
  datePickerConfigOT: {
    dateInputFormat: 'DD-MM-YYYY',
    containerClass: 'theme-dark-blue'
  },
  minYearSelectCalender: '1900',
  customTimePickerDropdown: {
    minutesInterval: 60, // default will be 5 minutes
    includeClosedOption: true // default will be true
  },
  yersOfExp: {
    min: 0,
    max: 99
  },
  //googleMapAPIKey: 'AIzaSyCSusGYQaEADvN9PO_cTrniZ-tjmR_4qSI',
  googleMapAPIKey: 'AIzaSyCocKHD4U4OVVTQPuead0OlhNSjC3sQVPU',
  apiRequestDateFormat: 'DD-MM-YYYY',
  deliveryRadius: {
    minlength: 0,
    maxlength: 60,
    pattern: "[0-9]*",
    min: 0, // in km
    max: 6356,  // in km
  },
  deliveryTime: {
    minlength: 0,
    maxlength: 60,
    pattern: "[0-9]*",
    min: 1, // in Min
    max: 1440,  // in Min
  },
  licenceAndGST: {
    // pattern: "^[a-zA-Z0-9]+(([-][a-zA-Z0-9])?[a-zA-Z0-9]*)*$",
    pattern: "^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$",
    // Licpattern: "^[a-zA-Z0-9]+(([-/][a-zA-Z0-9])?[a-zA-Z0-9]*)*$",
    Licpattern: "^[ A-Za-z0-9-/]*$",
    minlength: 0,
    maxlength: 60
  },
  hopitalPharmacyName: {
    pattern: "[a-zA-Z',. &-]*",
    hospital: {
      minlength: 0,
      maxlength: 80
    },
    pharmacy: {
      minlength: 0,
      maxlength: 80
    }
  },
  isFileUploadedToAWS: true,
  lifeStyle: {
    physicalActivity: [
      { name: 'Rare (0-1 Days)', value: 'Rare' },
      { name: 'Periodic (1-3 Days)', value: 'Periodic' },
      { name: 'Regular (3-5 Days)', value: 'Regular' },
      { name: 'Athletic (5-7 Days)', value: 'Athletic' }
    ],
    smokingHabits: [
      { name: 'None', value: 'None' },
      { name: 'Occasional', value: 'Occasional' },
      { name: 'Social', value: 'Social' },
      { name: 'Regular', value: 'Regular' },
      { name: 'Heavy', value: 'Heavy' }
    ],
    alcoholConsumption: [
      { name: 'None', value: 'None' },
      { name: 'Occasional', value: 'Occasional' },
      { name: 'Social', value: 'Social' },
      { name: 'Regular', value: 'Regular' },
      { name: 'Heavy', value: 'Heavy' }
    ],
    foodPreference: [
      { name: 'Vegetarian', value: 'Vegetarian' },
      { name: 'Non vegetarian', value: 'Non vegetarian' },
      { name: 'Eggetarian', value: 'Eggetarian' },
      { name: 'Vegan', value: 'Vegan' },
      { name: 'Gluten Free', value: 'Gluten Free' },
      { name: 'Ketosis', value: 'Ketosis' },
      { name: 'Pescatarian', value: 'Pescatarian' },
      { name: 'Other', value: 'Other' }
    ],
    sleepingHours: {
      min: 0,
      max: 24,
      postFix: 'Hrs'
    }
  },
  vitals: {
    blood_groups: [
      { name: 'O+', value: 'O+' },
      { name: 'O-', value: 'O-' },
      { name: 'A+', value: 'A+' },
      { name: 'A-', value: 'A-' },
      { name: 'B+', value: 'B+' },
      { name: 'B-', value: 'B-' },
      { name: 'AB+', value: 'AB+' },
      { name: 'AB-', value: 'AB-' },
    ]
  },
  medicalHistoryValidations: {
    title: {
      minlength: 0,
      maxlength: 70
    },
    symptoms: {
      minlength: 0,
      maxlength: 120
    },
    allowedFileUploadTypes: ['image/jpeg', 'image/jpg', 'application/pdf', 'image/png']
  },
  importValidations: {
    allowedFileUploadTypes: ['text/csv', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
  },
  doctorProfessional: {
    qualifications: {
      minlength: 0,
      maxlength: 60
    },
    further_specialization: {
      minlength: 0,
      maxlength: 60
    },
    address: {
      minlength: 0,
      maxlength: 120
    },
    fees: {
      pattern: "[0-9]*",
      minlength: 0,
      maxlength: 30
    },
    waitingTime: {
      pattern: "[a-zA-Z0-9]*",
      minlength: 0,
      maxlength: 30
    },
    serviceProvided: {
      minlength: 0,
      maxlength: 120
    }
  },
  pharmacy: {
    address: {
      minlength: 0,
      maxlength: 120
    },
    landmark: {
      minlength: 0,
      maxlength: 60
    }
  },
  occupation: {
    minlength: 0,
    maxlength: 60
  },
  dashboard: {
    
    searchPharmacyText: 'Search Pharmacy name to view the Analytics',
    searchHospitalText: 'Search Hospital name to view the Analytics',
    searchDoctorText: 'Search Doctor name to view the Analytics',
    noData: 'No data available',
    revenueChartTooltip: 'Compare total earnings against the number of orders.',
    revenueChartTooltiptp: 'Track the revenue generated from out-patient services.',
    testovertimetp: 'Compare the total number of lab tests with those distributed in OPD and IPD, showing trends in test advices across different areas of patient care.',
    pendingovertimeTP:'Gain insights into the number of pending reports over specified day ranges, highlighting workflow efficiency',
    highestValuePatientsToolip: 'Identify patients with the highest order values over one month, three months or the current financial year.',
    recurringOrdersTooltip: 'Track total orders distributed into unique and recurring orders, over one month, three months or the current financial year.',
    recurringOrdersTooltiptp: 'Depicts the distribution of total consultations distributed into appointments & walk-ins over one month, three months or the current financial year.',
    discountDistributionTooltip: 'Analyse the distribution of discounts applied on sales over the previous day, last month or the past three months.',
    averageOrderValueTooltip: 'Contrast the average values of orders over one month, three months or the current financial year.',
    averageOrderValueTooltiptp: 'Analyze the frequency of various symptoms across consultations, offering insights into common health complaints amongst patients.',
    highFreqMed: 'Find out which medicines consistently feature in sales. This shows your top-selling products based on the frequency over the last 24 hours, one month or three months.',
    highQtyMed: 'Identify the top-selling medicines based on quantity sold. This highlights which medicines are in high demand from over the last 24 hours, one month or three months.',
    highValvsHighPrice: 'Highest Value SKUs shows items in-stock, consuming a significant portion of your inventory investment, and Highest Priced SKUs highlights items in-stock with the highest sale prices. Hover on the bars for exact values.',
    totalInvValue: 'Estimated MRP value of all items in stock. (Graph shown below is strictly representational)',
    estimatedTooltip:'Represents the estimated income from in-patient services (Graph shown below is strictly representational)',
    bedcoccupiedTooltip:'Showcases the number of occupied and unoccupied beds in each ward to gain insights into capacity utilization and optimize space allocation',
    insightsTooltip: 'Analyse new and recurring patients. Our live chart helps you understand patient trends at a glance.',
    inactivePatienthospitalTooltip: 'Track patients who have been inactive over a period of time, offering insights into patient management, resource allocation, and potential areas for intervention.',

    PatientFootfall : 'Analyse OPD, IPD and Emergency patient footfall. Our live chart helps you understand patient trends at a glance.',
    HighestvaluePatientTooltipHospital: `Identify patients with the highest expenditures over one month, three months or the current financial year, providing insights into high-value clientele.`,
    LongterminactiveTooltip: `Track patients who haven't purchased from your store over a period of time. Enhance your outreach efforts to regain them.`,
    patientDistTooltip: `Check the number of patients with a phone number and those without. It's a quick look at how many people you can contact easily.`,
    patientvisitdisthospital: `Analyse the distribution of patient visits based on different visit types, providing insights into patient flow, service demand, and operational efficiency.`,
    patLifeCycleTooltip: 'View the distribution of the periods through which patients have been consistently making purchases from your store.',
    predictionTooltip: 'Analyze predicted sales for the highest selling items in your inventory. Optimize stock based on these insights to prevent unforeseen stock-outs or overstocking. Predictions are calculated in the last week of every month for the next calendar month.',
    inactivePatientTooltip: `Track patients who haven't purchased from your store over a period of time. Enhance your outreach efforts to regain them.`,
    // Purchaser
    purchaserevenueChartTooltip: 'Track the trends in purchase values and number of purchase orders.',
    purchasehighestValuePatientsToolip: 'Identify top suppliers according to purchase values or outstanding values over one month, three months or the current financial year.',
    purchaserecurringOrdersTooltip: 'Analyze payment trends (paid vs. unpaid orders by payment method) for one month, three months or the current financial year, to identify preferences and cash flow risks.',
    purchasepredictionTooltip: 'Gain instant insights into most profitable products and supplier deals. This analysis breaks down profit margins by product and supplier, allowing you to quickly identify areas for optimization.',
    // OPD
    AppointmentsvsWalkins: 'Depicts the distribution of total consultations distributed into appointments & walk-ins over one month, three months or the current financial year.',
    RevenueTrend: 'Track the revenue generated from out-patient services.',
    SymptomsFrequencyDistribution: 'Analyze the frequency of various symptoms across consultations, offering insights into common health complaints amongst patients.',
    frequencyTP: ' Identify the top 5 most frequently performed tests in the lab over one month, three months, or the current financial year.',
    revenuetp: 'Track the distribution of revenue across insurance payments, outstanding balances, and collected payments, providing insights into accounting ledgers.',
    revenubyverticaltp:'Identify the top departments by revenue, showcasing the total & average distribution of revenue across various verticals.',
    dischargetypeTP:' Analyse the distribution of patient discharges based on different discharge types, providing insights into clinical outcomes of admitted patients.',
    dusrationbydistributiontp:'Gain insights into the length of time patients typically spend in the hospital over weekly intervals, highlighting trends in patient care and occupancies.',
    procedurenameovertimetp:'This analysis tracks the number of procedures scheduled, providing insights into procedural trends and operational planning.',
    manpowerDis:'Gain insights into resource and manpower allocation for specific procedures on a selected date, helping to understand and optimize staff utilization.',
  }
};
